var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "klienti-container" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("klient-medicom"),
      _vm._v(" "),
      _c("Footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "klienti-heading" }, [
        _c("h1", [_vm._v("Klienti")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "loreal-heading" }, [
          _c("h2", [
            _vm._v("\n                    L'Oréal "),
            _c("br"),
            _vm._v("\n                    Česká republika\n                ")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Possimus laudantium sit accusantium quidem neque provident voluptas optio perspiciatis molestias dolor porro dicta mollitia nemo modi eligendi quaerat numquam, consequuntur ad."
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "loreal-img-container" }, [
          _c("img", {
            attrs: { src: "/theme/images/klienti/zendaya-hero.webp", alt: "" }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "loreal-text" }, [
          _c("p", [
            _vm._v(
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit praesentium eos dolor nulla enim, obcaecati sequi, blanditiis quidem deserunt ut nam ratione quam cumque facilis aspernatur illum quos facere ducimus."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi mollitia ab voluptates, fuga possimus omnis ut tempore nisi id accusamus! Molestias, modi. Blanditiis cumque dolorem non nisi labore vel ipsam?"
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "nums-grid" }, [
          _c("div", { staticClass: "num-item" }, [
            _c("span", { staticClass: "num" }, [_vm._v("60+")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "num-item" }, [
            _c("span", { staticClass: "num" }, [_vm._v("6+")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "num-item" }, [
            _c("span", { staticClass: "num" }, [_vm._v("7+")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "num-item" }, [
            _c("span", { staticClass: "num" }, [_vm._v("720+")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }